import axios from "@/axios";

import Util from "../../../../util/util";

import moment from "moment";

export const namespaced = true;

const defaultData = {
  id: 0,
  isPartialReturn: true,
  deliveryReturnPlace: null,
  deliveryReturnUnit: null,
  deliveryReturnCountryId: null,
  returnSignerName: null,
  returnUnitOffice: null,
  returnOrganizationId: null,
  returnSignature: {
    signatureId: 0,
    type: "TEXT",
    text: null,
    fontFamily: null,
    edit: null,
    view: null,
  },
  returnSignatureId: 6,
  returnDateRequested: null,
  returnDateSigned: null,
  initialDeliverySchedule: null,
  returnDeliverySchedule: null,
  organizations: [],
};

const resetData = {
  type: "TEXT",
  text: null,
  fontFamily: null,
  edit: null,
  view: null,
};
const IMAGE_EXP = "data:image\/[a-z]+;base64,";
export const state = {
  returnReplacementReceiptAcknowledgment: Object.assign({}, defaultData),
  helper: { countryId: 0, buySell: "" },
  status: false,
  enabled: false,
  returnReplacementErrors: [],
};

export const getters = {
  returnReplacementReceiptAcknowledgment: (state) => state.returnReplacementReceiptAcknowledgment,
  returnReplacementReceiptAcknowledgmentStatus: (state) => state.status,
  returnReplacementReceiptAcknowledgmentHelper: (state) => state.helper,
  returnReplacementReceiptAcknowledgmentEnabled: (state) => state.enabled,
  returnReplacementErrors: (state) => state.returnReplacementErrors,
};

export const mutations = {
  SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_API: (state, response) => {
    state.returnReplacementReceiptAcknowledgment = Object.assign({}, state.returnReplacementReceiptAcknowledgment, response.data, { returnSignature: response.data.returnSignature ? response.data.returnSignature : defaultData.returnSignature });

    if (state.returnReplacementReceiptAcknowledgment.returnSignature.edit && !state.returnReplacementReceiptAcknowledgment.returnSignature.edit.match(IMAGE_EXP)) {
      state.returnReplacementReceiptAcknowledgment.returnSignature.edit = window.atob(state.returnReplacementReceiptAcknowledgment.returnSignature.edit)
    }

    if (state.returnReplacementReceiptAcknowledgment.returnSignature.view && !state.returnReplacementReceiptAcknowledgment.returnSignature.view.match(IMAGE_EXP)) {
      state.returnReplacementReceiptAcknowledgment.returnSignature.view = window.atob(state.returnReplacementReceiptAcknowledgment.returnSignature.view)
    }
  },
  SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_SIG: (state, response) => {
    var returnSig =  Object.assign({}, response.data.returnSignature ? response.data.returnSignature : defaultData.returnSignature);
    returnSig.edit = window.atob(returnSig.edit);
    returnSig.view = window.atob(returnSig.view);
    state.returnReplacementReceiptAcknowledgment.returnSignature = returnSig;
  },

  SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_DATA: (state, data) => {
    state.returnReplacementReceiptAcknowledgment = Object.assign({}, state.returnReplacementReceiptAcknowledgment, data)
  },
  SET_STATUS: (state, status) => state.status = status,
  SET_HELPER: (state, value) => state.helper = value,
  SET_ENABLED: (state, response) => state.enabled = response.data,
  CLEAR_DATA: (state) => (state.returnReplacementReceiptAcknowledgment = defaultData),
  SET_ERRORS: (state, data) => (state.returnReplacementErrors = data),
  CLEAR_ERRORS: (state) => (state.returnReplacementErrors = [])
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },

  async getReturnReplacementReceiptAcknowledgmentStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_STATUS", false);
    } else {
      return await axios

        .get(`/api/replacementacknowlegments/order/status/${id}`)

        .then(({ data }) => {
          if (data && data.length === 0) {
            commit("SET_STATUS", true);
            commit("CLEAR_ERRORS");
          } else {
            commit("SET_STATUS", false);
            commit("SET_ERRORS", data);
          }
        });
    }
  },

  async getReturnReplacementReceiptAcknowledgmentEnabled({ commit }, orderId) {
    return await axios

      .get(`/api/replacementacknowlegments/order/enabled/${orderId}`)

      .then((response) => commit("SET_ENABLED", response));
  },

  async getReturnReplacementReceiptAcknowledgmentHelper({ commit }, id) {
    if (id == 0) {
      commit("SET_HELPER", { countryId: 0, buySell: "" });
    } else {
      return await axios

        .get("/api/signatures/helper/" + id)

        .then(({ data }) => commit("SET_HELPER", data));
    }
  },

  async getReturnReplacementReceiptAcknowledgment({ commit }, orderId) {
    try {
      commit("SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_API",
        await axios.get(`/api/replacementacknowlegments/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING RETURN REPLACEMENT RECEIPT ACKNOWLEDGMENT: ", error); //not handelled
    }
  },

  async getReturnReplacementReceiptAcknowledgmentSigOnly({ commit }, orderId) {
    try {
      commit("SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_SIG",
        await axios.get(`/api/replacementacknowlegments/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING RETURN REPLACEMENT RECEIPT ACKNOWLEDGMENT: ", error); //not handelled
    }
  },

  getCacSignature({ state, dispatch }, w) {
    return new Promise((resolve, reject) => {
      axios.get("/api/signatures/certificatename")
        .then(function (response) {
          const cacSignature = "data:image/jpg;base64," + response.data;
          dispatch("setSignature", cacSignature);
          return resolve();
        })
        .catch(function (error) {
          return reject(`There was an error getting the CAC signature...  ${error.response.data}`);
        });
    });
  },

  setSignature({ commit, state }, signature) {
    let date = null;

    if (!Util.isNullOrEmpty(signature)) {
      date = Util.convertToDateOnly(moment.utc().format("MM-DD-y HH:mm:ss"));
    }

    commit("SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_DATA", { returnSignature: Object.assign({}, state.returnReplacementReceiptAcknowledgment.returnSignature, signature), returnDateSigned: date });
  },

  async getOrganizations({ commit, state }, params) {
    try {
      let response = []

      if (params.buySell === "SELL") {

        response = await axios.get("/api/organizations/countrycode/US");

        let organizationId = (response && response.data) ? state.returnReplacementReceiptAcknowledgment.returnOrganizationId : null

        commit("SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_DATA", { organizations: response.data, returnOrganizationId: organizationId });
      }

      else if (params.buySell === "BUY" && params.countryId) {

        response = await axios.get(`/api/organizations/countryid/${params.countryId}`);

        let organizationId = (response && response.data) ? state.returnReplacementReceiptAcknowledgment.returnOrganizationId : null

        commit("SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_DATA", { organizations: response.data, returnOrganizationId: organizationId });
      }

      let found = response.data.find(item => item.id === state.returnReplacementReceiptAcknowledgment.returnOrganizationId);

      if (params.preOrderDetailStatus && params.agreementInformationStatus && !found) {
        commit("SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_DATA", { returnOrganizationId: null });
      }
    }
    catch (error) {
      commit("SET_RETURN_REPLACEMENT_RECEIPT_ACKNOWLEDGMENT_DATA", { returnOrganizationId: null, organizations: [] });
    }
  },

  saveReturnReplacementReceiptAcknowledgment({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let returned = Object.assign({}, state.returnReplacementReceiptAcknowledgment, {
        orderId: data['orderId'],
        returnSignature: (!state.returnReplacementReceiptAcknowledgment.returnSignature.view) ? null :
          {
            ...state.returnReplacementReceiptAcknowledgment.returnSignature,
            edit: (state.returnReplacementReceiptAcknowledgment.returnSignature.edit) ? window.btoa(state.returnReplacementReceiptAcknowledgment.returnSignature.edit) : "",
            view: (state.returnReplacementReceiptAcknowledgment.returnSignature.view) ? window.btoa(state.returnReplacementReceiptAcknowledgment.returnSignature.view) : "",
          },
        returnDateSigned: Util.convertToDateOnly(state.returnReplacementReceiptAcknowledgment.returnDateSigned),
        pin: (state.returnReplacementReceiptAcknowledgment.returnSignature.view) ? data.pin : null 
      });
      axios.post("/api/replacementacknowlegments", returned, { config: { showToast: false } })
        .then(function (response) {
          return dispatch("getReturnReplacementReceiptAcknowledgment", data.orderId);
        })
        .then(function () {
          return resolve();
        })
        .catch(function (error) {
          return reject(`There was an error saving Returned to the server...  ${error.response.data}`);
        });
    });
  },
};
